import { createSlice } from '@reduxjs/toolkit';
import { TaxonomyState } from '../../types';

export const initialState = {
  header: {},
  footer: {},
  headerClientLoading: true,
  footerClientLoading: true,
  progressiveHeaderClientLoading: true,
} as TaxonomyState;

export const taxonomySlice = createSlice({
  name: 'taxonomy',
  initialState,
  reducers: {
    setHeaderTaxo(state, action) {
      return { ...state, header: action.payload };
    },
    setFooterTaxo(state, action) {
      return { ...state, footer: action.payload };
    },
    setProgressiveHeaderTaxo(state, action) {
      return { ...state, progressiveHeader: action.payload };
    },
    setHeaderFeaturedTaxo(state, action) {
      return { ...state, headerFeatured: action.payload };
    },
    setHeaderClientLoadingState(state, action) {
      return { ...state, headerClientLoading: action.payload };
    },
    setFooterClientLoadingState(state, action) {
      return { ...state, footerClientLoading: action.payload };
    },
    setProgressiveHeaderClientLoadingState(state, action) {
      return { ...state, progressiveHeaderClientLoading: action.payload };
    },
  },
});

export const {
  setHeaderTaxo,
  setProgressiveHeaderTaxo,
  setHeaderFeaturedTaxo,
  setFooterTaxo,
  setHeaderClientLoadingState,
  setProgressiveHeaderClientLoadingState,
  setFooterClientLoadingState,
} = taxonomySlice.actions;

export default taxonomySlice.reducer;
